import { api_ia } from '../config/config';

const tokenStore = "tok";

function LogOut() {
  const token   = sessionStorage.getItem(tokenStore);
  const usuario = JSON.parse(sessionStorage.getItem("usuario") || "null");

  if (usuario?.id && token) {
    fetch(`${api_ia}api/logout/${usuario.id}`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
      keepalive: true
    }).catch(() => {});
  }

  sessionStorage.setItem(tokenStore, "");
  sessionStorage.setItem("chatbot-conversation-id", "");
  sessionStorage.setItem("chatbot-messages", "");
  sessionStorage.removeItem("chatbot_enabled");
  sessionStorage.removeItem("chatbot-session-id");
  window.location.href = "/login";
}

export default LogOut;
